import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import defaultRemoveConfirmation from '@wix/da-shared-react/pkg/widgets/defaultRemoveConfirmation';
import ProfileCommentsBox from './ProfileCommentsBox';
import profileCommentsInit from './redux/profileCommentsInit';

export const getProfileCommentsWidgetConfig = ({
  t,
  dispatch,
}): WidgetConfig => ({
  viewComponent: ProfileCommentsBox,
  confirmRemove: () => defaultRemoveConfirmation({ t, dispatch }),
  widgetCard: {
    minuatureImageSrc:
      'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-9-profile-comments.svg',
    title: t('widgets.profileComments.addButtonHeader'),
    description: t('widgets.profileComments.description'),
  },
  initActionsCreator: profileCommentsInit,
});
